import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _03f504b6 = () => interopDefault(import('../pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))
const _fbf54b6e = () => interopDefault(import('../pages/_slug/widgets/articles-grid.vue' /* webpackChunkName: "pages/_slug/widgets/articles-grid" */))
const _0e462a7d = () => interopDefault(import('../pages/_slug/widgets/badge-label.vue' /* webpackChunkName: "pages/_slug/widgets/badge-label" */))
const _08108c90 = () => interopDefault(import('../pages/_slug/widgets/badge-number.vue' /* webpackChunkName: "pages/_slug/widgets/badge-number" */))
const _185f0ebc = () => interopDefault(import('../pages/_slug/widgets/badge-pictures.vue' /* webpackChunkName: "pages/_slug/widgets/badge-pictures" */))
const _90b94b32 = () => interopDefault(import('../pages/_slug/widgets/badge-rate.vue' /* webpackChunkName: "pages/_slug/widgets/badge-rate" */))
const _58bda415 = () => interopDefault(import('../pages/_slug/widgets/companies-grid.vue' /* webpackChunkName: "pages/_slug/widgets/companies-grid" */))
const _a896228a = () => interopDefault(import('../pages/_slug/widgets/companies-infinite-slider.vue' /* webpackChunkName: "pages/_slug/widgets/companies-infinite-slider" */))
const _a6ee1f3e = () => interopDefault(import('../pages/_slug/widgets/endorsement.vue' /* webpackChunkName: "pages/_slug/widgets/endorsement" */))
const _53be8201 = () => interopDefault(import('../pages/_slug/widgets/endorsements-grid.vue' /* webpackChunkName: "pages/_slug/widgets/endorsements-grid" */))
const _443c654f = () => interopDefault(import('../pages/_slug/widgets/endorsements-infinite-slider.vue' /* webpackChunkName: "pages/_slug/widgets/endorsements-infinite-slider" */))
const _4b7a2c17 = () => interopDefault(import('../pages/_slug/widgets/endorsements-step-slider.vue' /* webpackChunkName: "pages/_slug/widgets/endorsements-step-slider" */))
const _6d92edc6 = () => interopDefault(import('../pages/_slug/widgets/example.vue' /* webpackChunkName: "pages/_slug/widgets/example" */))
const _af20cb5a = () => interopDefault(import('../pages/_slug/widgets/qualities-grid.vue' /* webpackChunkName: "pages/_slug/widgets/qualities-grid" */))
const _35597486 = () => interopDefault(import('../pages/_slug/widgets/qualities-infinite-slider.vue' /* webpackChunkName: "pages/_slug/widgets/qualities-infinite-slider" */))
const _400318f6 = () => interopDefault(import('../pages/_slug/widgets/qualities-step-slider.vue' /* webpackChunkName: "pages/_slug/widgets/qualities-step-slider" */))
const _1ba66632 = () => interopDefault(import('../pages/_slug/widgets/quality.vue' /* webpackChunkName: "pages/_slug/widgets/quality" */))
const _459c063f = () => interopDefault(import('../pages/_slug/qualite/_qualities.vue' /* webpackChunkName: "pages/_slug/qualite/_qualities" */))
const _2b78d1b6 = () => interopDefault(import('../pages/_slug/reference/_references.vue' /* webpackChunkName: "pages/_slug/reference/_references" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/profil/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en-GB/:slug",
    component: _03f504b6,
    name: "slug___en-GB"
  }, {
    path: "/es-ES/:slug",
    component: _03f504b6,
    name: "slug___es-ES"
  }, {
    path: "/en-GB/:slug?/widgets/articles-grid",
    component: _fbf54b6e,
    name: "slug-widgets-articles-grid___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/badge-label",
    component: _0e462a7d,
    name: "slug-widgets-badge-label___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/badge-number",
    component: _08108c90,
    name: "slug-widgets-badge-number___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/badge-pictures",
    component: _185f0ebc,
    name: "slug-widgets-badge-pictures___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/badge-rate",
    component: _90b94b32,
    name: "slug-widgets-badge-rate___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/companies-grid",
    component: _58bda415,
    name: "slug-widgets-companies-grid___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/companies-infinite-slider",
    component: _a896228a,
    name: "slug-widgets-companies-infinite-slider___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/endorsement",
    component: _a6ee1f3e,
    name: "slug-widgets-endorsement___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/endorsements-grid",
    component: _53be8201,
    name: "slug-widgets-endorsements-grid___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/endorsements-infinite-slider",
    component: _443c654f,
    name: "slug-widgets-endorsements-infinite-slider___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/endorsements-step-slider",
    component: _4b7a2c17,
    name: "slug-widgets-endorsements-step-slider___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/example",
    component: _6d92edc6,
    name: "slug-widgets-example___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/qualities-grid",
    component: _af20cb5a,
    name: "slug-widgets-qualities-grid___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/qualities-infinite-slider",
    component: _35597486,
    name: "slug-widgets-qualities-infinite-slider___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/qualities-step-slider",
    component: _400318f6,
    name: "slug-widgets-qualities-step-slider___en-GB"
  }, {
    path: "/en-GB/:slug?/widgets/quality",
    component: _1ba66632,
    name: "slug-widgets-quality___en-GB"
  }, {
    path: "/es-ES/:slug?/widgets/articles-grid",
    component: _fbf54b6e,
    name: "slug-widgets-articles-grid___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/badge-label",
    component: _0e462a7d,
    name: "slug-widgets-badge-label___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/badge-number",
    component: _08108c90,
    name: "slug-widgets-badge-number___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/badge-pictures",
    component: _185f0ebc,
    name: "slug-widgets-badge-pictures___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/badge-rate",
    component: _90b94b32,
    name: "slug-widgets-badge-rate___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/companies-grid",
    component: _58bda415,
    name: "slug-widgets-companies-grid___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/companies-infinite-slider",
    component: _a896228a,
    name: "slug-widgets-companies-infinite-slider___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/endorsement",
    component: _a6ee1f3e,
    name: "slug-widgets-endorsement___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/endorsements-grid",
    component: _53be8201,
    name: "slug-widgets-endorsements-grid___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/endorsements-infinite-slider",
    component: _443c654f,
    name: "slug-widgets-endorsements-infinite-slider___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/endorsements-step-slider",
    component: _4b7a2c17,
    name: "slug-widgets-endorsements-step-slider___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/example",
    component: _6d92edc6,
    name: "slug-widgets-example___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/qualities-grid",
    component: _af20cb5a,
    name: "slug-widgets-qualities-grid___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/qualities-infinite-slider",
    component: _35597486,
    name: "slug-widgets-qualities-infinite-slider___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/qualities-step-slider",
    component: _400318f6,
    name: "slug-widgets-qualities-step-slider___es-ES"
  }, {
    path: "/es-ES/:slug?/widgets/quality",
    component: _1ba66632,
    name: "slug-widgets-quality___es-ES"
  }, {
    path: "/en-GB/:slug?/qualite/:qualities?",
    component: _459c063f,
    name: "slug-qualite-qualities___en-GB"
  }, {
    path: "/en-GB/:slug?/reference/:references?",
    component: _2b78d1b6,
    name: "slug-reference-references___en-GB"
  }, {
    path: "/es-ES/:slug?/qualite/:qualities?",
    component: _459c063f,
    name: "slug-qualite-qualities___es-ES"
  }, {
    path: "/es-ES/:slug?/reference/:references?",
    component: _2b78d1b6,
    name: "slug-reference-references___es-ES"
  }, {
    path: "/:slug",
    component: _03f504b6,
    name: "slug___fr-FR"
  }, {
    path: "/:slug?/widgets/articles-grid",
    component: _fbf54b6e,
    name: "slug-widgets-articles-grid___fr-FR"
  }, {
    path: "/:slug?/widgets/badge-label",
    component: _0e462a7d,
    name: "slug-widgets-badge-label___fr-FR"
  }, {
    path: "/:slug?/widgets/badge-number",
    component: _08108c90,
    name: "slug-widgets-badge-number___fr-FR"
  }, {
    path: "/:slug?/widgets/badge-pictures",
    component: _185f0ebc,
    name: "slug-widgets-badge-pictures___fr-FR"
  }, {
    path: "/:slug?/widgets/badge-rate",
    component: _90b94b32,
    name: "slug-widgets-badge-rate___fr-FR"
  }, {
    path: "/:slug?/widgets/companies-grid",
    component: _58bda415,
    name: "slug-widgets-companies-grid___fr-FR"
  }, {
    path: "/:slug?/widgets/companies-infinite-slider",
    component: _a896228a,
    name: "slug-widgets-companies-infinite-slider___fr-FR"
  }, {
    path: "/:slug?/widgets/endorsement",
    component: _a6ee1f3e,
    name: "slug-widgets-endorsement___fr-FR"
  }, {
    path: "/:slug?/widgets/endorsements-grid",
    component: _53be8201,
    name: "slug-widgets-endorsements-grid___fr-FR"
  }, {
    path: "/:slug?/widgets/endorsements-infinite-slider",
    component: _443c654f,
    name: "slug-widgets-endorsements-infinite-slider___fr-FR"
  }, {
    path: "/:slug?/widgets/endorsements-step-slider",
    component: _4b7a2c17,
    name: "slug-widgets-endorsements-step-slider___fr-FR"
  }, {
    path: "/:slug?/widgets/example",
    component: _6d92edc6,
    name: "slug-widgets-example___fr-FR"
  }, {
    path: "/:slug?/widgets/qualities-grid",
    component: _af20cb5a,
    name: "slug-widgets-qualities-grid___fr-FR"
  }, {
    path: "/:slug?/widgets/qualities-infinite-slider",
    component: _35597486,
    name: "slug-widgets-qualities-infinite-slider___fr-FR"
  }, {
    path: "/:slug?/widgets/qualities-step-slider",
    component: _400318f6,
    name: "slug-widgets-qualities-step-slider___fr-FR"
  }, {
    path: "/:slug?/widgets/quality",
    component: _1ba66632,
    name: "slug-widgets-quality___fr-FR"
  }, {
    path: "/:slug?/qualite/:qualities?",
    component: _459c063f,
    name: "slug-qualite-qualities___fr-FR"
  }, {
    path: "/:slug?/reference/:references?",
    component: _2b78d1b6,
    name: "slug-reference-references___fr-FR"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
